import { render, staticRenderFns } from "./ShowFirebasePushNotification.vue?vue&type=template&id=1a5dd7cc"
import script from "./ShowFirebasePushNotification.vue?vue&type=script&lang=ts"
export * from "./ShowFirebasePushNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports